import React from 'react';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './App.css';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
</StrictMode>
);

serviceWorker.unregister();
